import { range } from 'lodash';
import React, { FC, HTMLAttributes } from 'react';
import ContentLoader from 'react-content-loader';
import { PAGE_SIZE } from '@hypercharge/digitaldealer-commons/lib/constants';
import styled from 'styled-components';

// use v6 prop names: backgroundColor / foregroundColor
const RowLoader: FC = () => (
  <ContentLoader
    height={31}
    width={840}
    speed={6}
    backgroundColor="#f4f4f6"
    foregroundColor="#ecebeb"
  >
    <rect x="10" y="0" rx="0" ry="0" width="820" height="31" />
  </ContentLoader>
);

const FilledRowResultsLoader: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <div {...(props as any)}>
      {range(PAGE_SIZE).map((_, index) => (
        <RowLoader key={`results-loader-${index}`} />
      ))}
    </div>
  );
};

const RowResultsLoader = styled(FilledRowResultsLoader)`
  :first-child {
    margin-top: 8px;
  }
`;

export default RowResultsLoader;
